/**
 * 全站权限配置
 *
 */
import { clearCookies, getCookie, setCookie } from './utils/cookie';

import router from '@/router';

/**
 * 导航守卫，相关内容可以参考:
 * https://router.vuejs.org/zh/guide/advanced/navigation-guards.html
 */
router.beforeEach((to, from, next) => {
    const hasValidParams = Object.keys(to.query).some(key => {
        const value = to.query[key];
        return value !== undefined && value !== ''; // 排除 undefined 和 空字符串
    });
    if (hasValidParams) {
        if (to.query.partner_uuid) {
            sessionStorage.setItem('queryParams', JSON.stringify(to.query))
            setCookie('queryParams', JSON.stringify(to.query))
        }
        console.log('to.query 包含有效参数:', to.query);
    } else {
        console.log('to.query 没有有效参数');
    }

    let html = document.getElementsByTagName('html')[0]
    html.scrollTop = 0
    next()
});

router.afterEach(() => {});